import { createAsyncThunk } from '@reduxjs/toolkit';
import { getHouseResidentsReport, getHouseReport } from "../../api"
import _, { get, findIndex } from "lodash";
import { RESIDENT_TYPE, SCREENS } from "../../constants";
import { setMoodEnergyChartData, setPieChartData, setModulesAvgs, setTableInsights } from "../top"
import { parseUsersTableData, parseUsersTopData } from "../../parsers"

export const getUsersTopData = createAsyncThunk('users/getTopData', async (data) => {
    const { startDate, endDate, compareTrendKey, tags, tagFilteringMode } = data
    const response = await getHouseReport(startDate, endDate, compareTrendKey, tags, tagFilteringMode)
    console.log("res", response)
    const parsed = parseUsersTopData(response.data)
    return {...parsed, startDate, endDate}
})

export const getUsersTableData = createAsyncThunk('users/getTableData', async (data) => {
    const { startDate, endDate, compareTrendKey, tags, houseType, tagFilteringMode, page, pageSize } = data
    const response = await getHouseResidentsReport(startDate, endDate, compareTrendKey, tags, tagFilteringMode, page, pageSize)
    const parsed = parseUsersTableData(response.data)
    return { data: parsed, pagination: response.pagination }
})

const handleUsersData = (data, houseType) => {
    const indexOfPublicModeResident = findIndex(data, (d) => {
        return get(d, "resident.type", "") === RESIDENT_TYPE.MULTI
    })
    if (indexOfPublicModeResident !== -1) {
        data.splice(indexOfPublicModeResident, 1)
    }
    if (houseType === "org") {
        data = _.cloneDeep(removeResidentsOfType(data))
    }
    data = parseUsersTableData(data)
    return data
}

const removeResidentsOfType = (data) => {
    return data.filter(d => get(d, "resident.type", "") !== RESIDENT_TYPE.GROUP && get(d, "resident.type", "") !== RESIDENT_TYPE.CARE)
}
